import React from 'react';
import { resolveSlotType } from '../../data/mealSlotTypes';
import './SpecialtyPlans.css';

export default function MealSlotBadge({ slot, slotId, compact = false }) {
  const type = resolveSlotType(slot || slotId) || { label: slot || slotId, className: 'sp-slot-type--default' };
  const Icon = type.icon;

  return (
    <span className={`sp-slot-type ${type.className}${compact ? ' sp-slot-type--compact' : ''}`}>
      {Icon ? <Icon className="sp-slot-type__icon" aria-hidden /> : null}
      <span>{type.label}</span>
    </span>
  );
}
